<template>
  <div :class="style.controls">
    <button :class="style['vdp-button']" @click="closeDateWidget">{{ $t('close') }}</button>
    <button v-if="isReservationForm" :class="style['vdp-button']" @click="sendAndClose">
      {{ $t('select') }}
    </button>
    <button
      v-if="!isReservationForm && !closeOnly"
      :disabled="disableSend"
      :class="style['vdp-button']"
      @click="sendAndClose"
    >
      {{ $t('send') }}
    </button>
  </div>
</template>

<script>
import style from '../scss/_bottompanel.scss'
import { useBottomPanelStore } from 'Store/bottom-panel'
import { useDatepickerStore } from 'Store/datepicker'

export default {
  setup() {
    return {
      bottomPanelStore: useBottomPanelStore(),
      datepickerStore: useDatepickerStore()
    }
  },

  props: {
    closeOnly: { type: Boolean, default: false }
  },
  data() {
    return {
      style
    }
  },
  computed: {
    disableSend() {
      if (!this.datepickerStore.useDateRange || this.datepickerStore.dateRange?.checkOut)
        return false

      return true
    },
    isReservationForm() {
      return this.bottomPanelStore.inputFor === 'ReservationForm'
    },
    isRestaurantForm() {
      return this.bottomPanelStore.inputFor === 'RestaurantForm'
    }
  },
  methods: {
    sendAndClose() {
      if (this.isReservationForm) {
        this.$emit('bottomPanelSelect')
      } else if (this.isRestaurantForm) {
        this.$emit('bottomPanelForm')
      } else {
        this.$emit('bottomPanelSend')
      }
      this.bottomPanelStore.setBottomPanelInputFor(null)
    },
    closeDateWidget() {
      this.bottomPanelStore.setBottomPanelComponent()
    }
  }
}
</script>
